module.exports = __webpack_public_path__ + "static/media/22.4e9e33ce.png";